import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid, Row, Col } from 'react-bootstrap';
import { Link, withRouter } from 'react-router-dom';
import queryString from 'query-string';
import { setExperiencesList, setExperienceSelected } from '../../../actions/experiences';
import ExperiencesDataListV2 from '../Data/ExperiencesV2';
import GetStartedImage from '../../../resources/GetStartedArrow.png';
import QuoteTicksImage from '../../../resources/QuoteTicks.png';
import ExperiencesTitle from '../../shs/ExperiencesTitle/ExperiencesTitle';
import getPartnerAsset, { DynamicAssetsKeys } from '../../../../../assets';

import { theme } from '../../../../../themes';

class TiledCards extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    if (!this.props.experiencesList || this.props.experiencesList.length == 0) {
      this.props.setExperiencesList(ExperiencesDataListV2);
    }
  }

  // TODO: factor out this function with the same one in file PopularExperiences.js
  getExperienceGetStartedLinkTo = (experience) => {
    const queryData = queryString.parse(window.location.search);
    const getRoutePath = getPartnerAsset(DynamicAssetsKeys.expertSessionsPath);
    const linkTo = {
      pathname: getRoutePath,
      search: '?megaUseCase=' + experience.megaUseCase,
    };
    return linkTo;
  };

  renderExperienceTile = (experience) => {
    if (!experience || !experience.tile) {
      return null;
    }
    return (
      <Col xs={12} sm={6} md={4} lg={4} key={experience.tile.title}>
        <Link className="linkTo" to={this.getExperienceGetStartedLinkTo(experience)}>
          <div className="tile experience">
            <div className="image" style={{ backgroundImage: 'url(' + experience.tile.imageSrc + ')' }} />
            <div className="title articleTitleFonts">{experience.tile.title}</div>
            <div className="textContainer">
              <textarea className="text subtitleFonts" rows="3" value={experience.tile.text} readOnly />
              <div className="overlayContaner subtitleFonts">
                <div className="overlay" />
                <div className="detailsLink" style={{ color: theme.colors.linkColorDark }}>
                  &nbsp; more &#8594;
                </div>
              </div>
            </div>
          </div>
        </Link>
      </Col>
    );
  };

  render() {
    return (
      <div className="TiledCardsContainer">
        <ExperiencesTitle />
        <Grid>
          <Row>
            {this.props.experiencesList &&
              this.props.experiencesList.map((item) => {
                return this.renderExperienceTile(item);
              })}
          </Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state /*, ownProps*/) => ({
  experiencesList:
    state.experiences.experiencesList && state.experiences.experiencesList.version === 2
      ? state.experiences.experiencesList.data
      : null,
  experienceSelected: state.experiences.experienceSelected,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      setExperiencesList,
      setExperienceSelected,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(TiledCards));



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/components/experiences/TiledCards/TiledCards.js